export default "__VITE_ASSET__CJT$jJrT__"